import { useCallback, useMemo } from 'react';

import { Input } from 'twyne-new.ui';

import { useCraftProp } from '@/components/builder/utils';

export default function InputProperty({ name, type, ...props }) {
  const { value = '', setValue } = useCraftProp(name)

  const valueKey = useMemo(() => {
    switch (type) {
      case 'radio':
      case 'checkbox':
        return 'checked'
      default:
        return 'value'
    }
  }, [type])

  const handleChange = useCallback(evt => setValue(evt.target[valueKey]), [setValue, valueKey])

  return <Input {...props}
    variant='accent'
    type={type}
    {...{ [valueKey]: value }}
    onChange={handleChange}
  />
}
